// extracted by mini-css-extract-plugin
export default {"tabItem":"TabBarV2_tabItem__FbGAw","tabActive":"TabBarV2_tabActive__J+hyd","tabHovered":"TabBarV2_tabHovered__SeWxZ"};